import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate, useLocation } from "react-router-dom";
import { Toaster } from "sonner";
import Landing from "@/pages/Landing";
import Admin from "@/pages/Admin";
import AuthCallback from "@/pages/AuthCallback";
import { CookieBanner } from "@/components/landing/CookieBanner";

function AppRouter() {
  const location = useLocation();
  // Process OAuth return synchronously during render (prevents race conditions)
  if (location.hash?.includes("session_id=")) {
    return <AuthCallback />;
  }
  return (
    <Routes>
      <Route path="/" element={<Landing />} />
      <Route path="/admin" element={<Admin />} />
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  );
}

function App() {
  return (
    <div className="App">
      <div className="grain-overlay" aria-hidden="true" />
      <Toaster position="top-center" richColors />
      <BrowserRouter>
        <AppRouter />
      </BrowserRouter>
      <CookieBanner />
    </div>
  );
}

export default App;
